// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.5
// source: roboverse_platform_protos/statekeeping/Reported/SpotFaults.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported";

export interface SpotFaults {
  activeFaults: SpotFaults_SpotFault[];
}

export interface SpotFaults_SpotFault {
  faultId: number;
  timeStampUTC: Date | undefined;
  severity: SpotFaults_SpotFault_Severity;
  message: string;
  clearable: boolean;
  faultType: SpotFaults_SpotFault_FaultType;
}

export enum SpotFaults_SpotFault_Severity {
  SEVERITY_UNKNOWN = 0,
  INFO = 1,
  WARNING = 2,
  ERROR = 3,
  UNRECOGNIZED = -1,
}

export function spotFaults_SpotFault_SeverityFromJSON(object: any): SpotFaults_SpotFault_Severity {
  switch (object) {
    case 0:
    case "SEVERITY_UNKNOWN":
      return SpotFaults_SpotFault_Severity.SEVERITY_UNKNOWN;
    case 1:
    case "INFO":
      return SpotFaults_SpotFault_Severity.INFO;
    case 2:
    case "WARNING":
      return SpotFaults_SpotFault_Severity.WARNING;
    case 3:
    case "ERROR":
      return SpotFaults_SpotFault_Severity.ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpotFaults_SpotFault_Severity.UNRECOGNIZED;
  }
}

export function spotFaults_SpotFault_SeverityToJSON(object: SpotFaults_SpotFault_Severity): string {
  switch (object) {
    case SpotFaults_SpotFault_Severity.SEVERITY_UNKNOWN:
      return "SEVERITY_UNKNOWN";
    case SpotFaults_SpotFault_Severity.INFO:
      return "INFO";
    case SpotFaults_SpotFault_Severity.WARNING:
      return "WARNING";
    case SpotFaults_SpotFault_Severity.ERROR:
      return "ERROR";
    case SpotFaults_SpotFault_Severity.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SpotFaults_SpotFault_FaultType {
  FAULT_TYPE_UNKNOWN = 0,
  BEHAVIOR = 1,
  SYSTEM = 2,
  /** SERVICE - unused */
  SERVICE = 3,
  UNRECOGNIZED = -1,
}

export function spotFaults_SpotFault_FaultTypeFromJSON(object: any): SpotFaults_SpotFault_FaultType {
  switch (object) {
    case 0:
    case "FAULT_TYPE_UNKNOWN":
      return SpotFaults_SpotFault_FaultType.FAULT_TYPE_UNKNOWN;
    case 1:
    case "BEHAVIOR":
      return SpotFaults_SpotFault_FaultType.BEHAVIOR;
    case 2:
    case "SYSTEM":
      return SpotFaults_SpotFault_FaultType.SYSTEM;
    case 3:
    case "SERVICE":
      return SpotFaults_SpotFault_FaultType.SERVICE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpotFaults_SpotFault_FaultType.UNRECOGNIZED;
  }
}

export function spotFaults_SpotFault_FaultTypeToJSON(object: SpotFaults_SpotFault_FaultType): string {
  switch (object) {
    case SpotFaults_SpotFault_FaultType.FAULT_TYPE_UNKNOWN:
      return "FAULT_TYPE_UNKNOWN";
    case SpotFaults_SpotFault_FaultType.BEHAVIOR:
      return "BEHAVIOR";
    case SpotFaults_SpotFault_FaultType.SYSTEM:
      return "SYSTEM";
    case SpotFaults_SpotFault_FaultType.SERVICE:
      return "SERVICE";
    case SpotFaults_SpotFault_FaultType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseSpotFaults(): SpotFaults {
  return { activeFaults: [] };
}

export const SpotFaults: MessageFns<SpotFaults> = {
  encode(message: SpotFaults, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.activeFaults) {
      SpotFaults_SpotFault.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpotFaults {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotFaults();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.activeFaults.push(SpotFaults_SpotFault.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpotFaults {
    return {
      activeFaults: globalThis.Array.isArray(object?.activeFaults)
        ? object.activeFaults.map((e: any) => SpotFaults_SpotFault.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SpotFaults): unknown {
    const obj: any = {};
    if (message.activeFaults?.length) {
      obj.activeFaults = message.activeFaults.map((e) => SpotFaults_SpotFault.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpotFaults>, I>>(base?: I): SpotFaults {
    return SpotFaults.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpotFaults>, I>>(object: I): SpotFaults {
    const message = createBaseSpotFaults();
    message.activeFaults = object.activeFaults?.map((e) => SpotFaults_SpotFault.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSpotFaults_SpotFault(): SpotFaults_SpotFault {
  return { faultId: 0, timeStampUTC: undefined, severity: 0, message: "", clearable: false, faultType: 0 };
}

export const SpotFaults_SpotFault: MessageFns<SpotFaults_SpotFault> = {
  encode(message: SpotFaults_SpotFault, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.faultId !== 0) {
      writer.uint32(8).uint64(message.faultId);
    }
    if (message.timeStampUTC !== undefined) {
      Timestamp.encode(toTimestamp(message.timeStampUTC), writer.uint32(18).fork()).join();
    }
    if (message.severity !== 0) {
      writer.uint32(24).int32(message.severity);
    }
    if (message.message !== "") {
      writer.uint32(34).string(message.message);
    }
    if (message.clearable !== false) {
      writer.uint32(40).bool(message.clearable);
    }
    if (message.faultType !== 0) {
      writer.uint32(48).int32(message.faultType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpotFaults_SpotFault {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotFaults_SpotFault();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.faultId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.timeStampUTC = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.clearable = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.faultType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpotFaults_SpotFault {
    return {
      faultId: isSet(object.faultId) ? globalThis.Number(object.faultId) : 0,
      timeStampUTC: isSet(object.timeStampUTC) ? fromJsonTimestamp(object.timeStampUTC) : undefined,
      severity: isSet(object.severity) ? spotFaults_SpotFault_SeverityFromJSON(object.severity) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      clearable: isSet(object.clearable) ? globalThis.Boolean(object.clearable) : false,
      faultType: isSet(object.faultType) ? spotFaults_SpotFault_FaultTypeFromJSON(object.faultType) : 0,
    };
  },

  toJSON(message: SpotFaults_SpotFault): unknown {
    const obj: any = {};
    if (message.faultId !== 0) {
      obj.faultId = Math.round(message.faultId);
    }
    if (message.timeStampUTC !== undefined) {
      obj.timeStampUTC = message.timeStampUTC.toISOString();
    }
    if (message.severity !== 0) {
      obj.severity = spotFaults_SpotFault_SeverityToJSON(message.severity);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.clearable !== false) {
      obj.clearable = message.clearable;
    }
    if (message.faultType !== 0) {
      obj.faultType = spotFaults_SpotFault_FaultTypeToJSON(message.faultType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpotFaults_SpotFault>, I>>(base?: I): SpotFaults_SpotFault {
    return SpotFaults_SpotFault.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpotFaults_SpotFault>, I>>(object: I): SpotFaults_SpotFault {
    const message = createBaseSpotFaults_SpotFault();
    message.faultId = object.faultId ?? 0;
    message.timeStampUTC = object.timeStampUTC ?? undefined;
    message.severity = object.severity ?? 0;
    message.message = object.message ?? "";
    message.clearable = object.clearable ?? false;
    message.faultType = object.faultType ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
